import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import {fetchDataFilter, getOptiosDDL, setInputValue} from "../service";

class InventoryPageFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataCategoryDDL: [],
            dataLocatorDDL: [],
            dataKSUDDL: [],
            dataGiftDDL: [],
            dataOtherItemDDL: []
        };
    }

    componentDidMount() {
        fetchDataFilter(
            this.props.type,
            this.setState.bind(this),
            {
                paramFilters: {kodeCabang: this.props.kodeCabang?.value}
            }
        )
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit();
    };

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <form onSubmit={this.handleSubmit}>
                            {
                                this.props.pageConfig && this.props.pageConfig.filter.map(
                                    (field) => {
                                        if (field.type === "SimpleDDL") {
                                            return (
                                                <SimpleDDL
                                                    key={field.name}
                                                    id={`select_options_filter_${field.name}`}
                                                    box={field.box}
                                                    name={field.name}
                                                    label={field.label}
                                                    isClearable={true}
                                                    options={getOptiosDDL(this.state, field.name)}
                                                    value={this.props.filterData[field.name]}
                                                    onChange={(value, {name}) =>
                                                        this.props.onValueChange(name, value)
                                                    }
                                                />
                                            );
                                        } else if (field.type === "SimpleInput") {
                                            return (
                                                <SimpleInput
                                                    key={field.name}
                                                    id={`input_text_${field.name}`}
                                                    name={field.name}
                                                    label={field.label}
                                                    readOnly={field.readOnly ? true : false}
                                                    value={setInputValue(field.name, this.state, this.props.filterData)}
                                                    onChange={({target}) =>
                                                        this.props.onValueChange(target.name, target.value?.trim())
                                                    }
                                                />
                                            )
                                        }
                                    }
                                )
                            }

                            <FlexView hAlignContent="right">
                                <SimpleButton type="button" secondary onClick={this.props.onClearForm}>
                                    Hapus
                                </SimpleButton>
                                <SimpleButton type="submit">Terapkan</SimpleButton>
                            </FlexView>
                        </form>
                    </ModalContainer>
                }
            />
        );
    }
}

export default InventoryPageFilter;